// Register only components present in the page, including quick-add fragments.
const pending = new Map([...document.querySelectorAll('script[data-optional-component]')].map(node => [node.dataset.optionalComponent, node.dataset.moduleUrl]));
const roots = new Set();
let frame;
function scan() {
  frame = undefined;
  const added = [...roots];
  roots.clear();
  for (const [tag, url] of pending) {
    if (!added.some(root => root.isConnected && (root.matches?.(tag) || root.querySelector?.(tag)))) continue;
    pending.delete(tag);
    import(url).catch(error => { pending.set(tag, url); console.warn(`Component ${tag} could not load`, error); });
  }
  if (!pending.size) observer.disconnect();
}
const observer = new MutationObserver(records => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType === 1) roots.add(node);
    }
  }
  if (roots.size && frame === undefined) frame = requestAnimationFrame(scan);
});
observer.observe(document.documentElement, {childList:true, subtree:true});
function initialScan() { roots.add(document.documentElement); scan(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialScan, {once:true});
else initialScan();
